export default __webpack_public_path__ + "static/media/stopDetecting.676d02b8.png";